import React, { useCallback, useEffect, useState } from "react";

import { addUser, getAllAdminUsers } from "services";

import { clearLocalKlimVar, incomplete, useCancelAsyncOnUnmount, useToggleNavs } from "utils";

import { Button, Col, Form, Input, MainPage, Option, Row, Select, Typography } from "components";

import { AccountLogo } from "pages/app/account/components/AccountLogo";

export const AdminAccessRequest = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isRequestConfirmed, setIsRequestConfirmed] = useState(false);
  const [users, setUsers] = useState([]);

  const signal = useCancelAsyncOnUnmount()();

  useToggleNavs(false, false);

  const loadAllUsers = useCallback(() => {
    getAllAdminUsers({
      signal,
    })
      .then((res) => {
        setUsers(res.length > 0 ? res : []);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [signal]);

  const complete = (v) => {
    setIsLoading(true);
    addUser({
      ...v,
      ...{ signal },
    })
      .then((res) => {
        clearLocalKlimVar("token");

        if (res.success) {
          setIsRequestConfirmed(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    clearLocalKlimVar("token");
    loadAllUsers();
  }, []); // eslint-disable-line

  const SignInForm = () => (
    <div>
      <Row>
        <Col>
          <Typography variant="paragraph-m" className="margin-bottom-0">
            Enter your details and select your <b>most direct manager</b> to request admin access. They will receive an email to confirm your access privaleges.
            <br />
            <br />
            <b>You may already have a user account.</b> If you do, requesting access will not work - sign in or reset your password instead.
          </Typography>
        </Col>
      </Row>
      <Form name="signin" className="margin-top-300" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
        <Row>
          <Col sm={12} md={12}>
            <Input name="firstName" label="First name" rules={[{ required: true }]} />
          </Col>
          <Col sm={12} md={12}>
            <Input name="lastName" label="Last name" rules={[{ required: true }]} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                },
              ]}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Select name="manager" label="Closest manager" rules={[{ required: true }]} showSearch>
              {users.map((user, i) => (
                <Option value={user.id} key={i} disabled={user.name.includes("Adiv")}>
                  {user.name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={isLoading} loading={isLoading}>
                Request admin access
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Item>
              <Button type="secondary" href="/sign-in" disabled={isLoading} loading={isLoading}>
                Back to sign in
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );

  return (
    <MainPage pageName={"sign-in-up"}>
      <Row className="mini-form">
        <Col>
          <AccountLogo />
          <Row>
            <Col>
              <Typography variant="h1">Admin access request</Typography>
            </Col>
          </Row>
          {!isRequestConfirmed ? (
            <SignInForm />
          ) : (
            <Row>
              <Col>
                <Typography variant="paragraph-m" className="margin-bottom-0">
                  A request has been sent to the person you selected.
                </Typography>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </MainPage>
  );
};
